module.exports = __webpack_public_path__ + "media/images/jfrog-3303f45d6ca0732e35dfea2fb20357be.png";